// Hero Trainers Data - Complete Version with 6 Programs Each

// Spider-Man's workout programs (already had 6)
const spiderManPrograms = [
    {
        id: 'web-slinger-training',
        name: 'Web Slinger Training',
        description: 'Develop the agility and core strength needed to swing through New York City',
        pattern: 'w@d^_~!',
        reps: 15,
        sets: 3,
        focus: 'Web Swinging Agility'
    },
    {
        id: 'spider-sense-conditioning',
        name: 'Spider Sense Conditioning',
        description: 'Lightning-fast reflexes and wall-crawling strength through bodyweight mastery',
        pattern: '^w@d_~',
        reps: 12,
        sets: 3,
        focus: 'Reflexive Movement'
    },
    {
        id: 'wall-crawler-workout',
        name: 'Wall Crawler Workout',
        description: 'Build the specific strength needed to defy gravity and climb any surface',
        pattern: '@w^d_!',
        reps: 18,
        sets: 3,
        focus: 'Anti-Gravity Strength'
    },
    {
        id: 'friendly-neighborhood-fitness',
        name: 'Friendly Neighborhood Fitness',
        description: 'Complete bodyweight conditioning for everyday heroics and crime fighting',
        pattern: 'w@~^d_',
        reps: 14,
        sets: 3,
        focus: 'Daily Hero Conditioning'
    },
    {
        id: 'spider-strength-protocol',
        name: 'Spider Strength Protocol',
        description: 'Proportional strength of a spider applied to human-scale bodyweight training',
        pattern: '^@wd~_',
        reps: 16,
        sets: 3,
        focus: 'Proportional Power'
    },
    {
        id: 'ultimate-spider-training',
        name: 'Ultimate Spider Training',
        description: 'The complete training regimen that transforms ordinary people into wall-crawling heroes',
        pattern: 'w@d^_~!',
        reps: 20,
        sets: 3,
        focus: 'Complete Spider Mastery'
    }
];

// Captain America's workout programs (already had 6)
const captainAmericaPrograms = [
    {
        id: 'super-soldier-training',
        name: 'Super Soldier Training',
        description: 'The complete training protocol that created the perfect human specimen',
        pattern: '$x&*w@d!',
        reps: 12,
        sets: 3,
        focus: 'Perfect Human Development'
    },
    {
        id: 'shield-bearer-workout',
        name: 'Shield Bearer Workout',
        description: 'Develop the strength and precision needed to wield the legendary vibranium shield',
        pattern: '&$*xw@',
        reps: 10,
        sets: 3,
        focus: 'Shield Mastery'
    },
    {
        id: 'brooklyn-brawler-conditioning',
        name: 'Brooklyn Brawler Conditioning',
        description: 'Street-smart training combining raw determination with scientific enhancement',
        pattern: 'w@$x&*',
        reps: 14,
        sets: 3,
        focus: 'Combat Conditioning'
    },
    {
        id: 'first-avenger-protocol',
        name: 'First Avenger Protocol',
        description: 'Leadership through example - the workout that inspires others to greatness',
        pattern: '$&x*w@!',
        reps: 16,
        sets: 3,
        focus: 'Leadership Strength'
    },
    {
        id: 'living-legend-training',
        name: 'Living Legend Training',
        description: 'Timeless strength training principles that work across any era',
        pattern: 'w@$&x*',
        reps: 11,
        sets: 3,
        focus: 'Timeless Power'
    },
    {
        id: 'sentinel-of-liberty',
        name: 'Sentinel of Liberty',
        description: 'The ultimate expression of human potential through balanced development',
        pattern: '$x&*w@d^!',
        reps: 13,
        sets: 3,
        focus: 'Peak Human Performance'
    }
];

// Wolverine's workout programs (expanded from 2 to 6)
const wolverinePrograms = [
    {
        id: 'berserker-rage-training',
        name: 'Berserker Rage Training',
        description: 'Unleash primal fury through savage, animalistic training methods',
        pattern: 'w@~^x&*!',
        reps: 25,
        sets: 3,
        focus: 'Primal Fury'
    },
    {
        id: 'adamantium-skeleton-workout',
        name: 'Adamantium Skeleton Workout',
        description: 'Build unbreakable strength to support an indestructible skeletal frame',
        pattern: '$x&*+=!',
        reps: 20,
        sets: 3,
        focus: 'Unbreakable Foundation'
    },
    {
        id: 'healing-factor-conditioning',
        name: 'Healing Factor Conditioning',
        description: 'Push beyond normal limits with rapid recovery training protocols',
        pattern: '^w@x&~*',
        reps: 30,
        sets: 3,
        focus: 'Rapid Recovery'
    },
    {
        id: 'weapon-x-protocol',
        name: 'Weapon X Protocol',
        description: 'Military-grade conditioning forged in the fires of experimentation',
        pattern: '$*x&w@^',
        reps: 22,
        sets: 3,
        focus: 'Military Precision'
    },
    {
        id: 'lone-wolf-training',
        name: 'Lone Wolf Training',
        description: 'Self-reliant conditioning for those who walk their own path',
        pattern: 'w@~^*&x',
        reps: 18,
        sets: 3,
        focus: 'Solo Strength'
    },
    {
        id: 'canadian-wilderness-workout',
        name: 'Canadian Wilderness Workout',
        description: 'Rugged outdoor conditioning that builds both body and character',
        pattern: '^*&xw@~!',
        reps: 24,
        sets: 3,
        focus: 'Wilderness Survival'
    }
];

// Deadpool's workout programs (expanded from 1 to 6)
const deadpoolPrograms = [
    {
        id: 'maximum-effort-mayhem',
        name: 'Maximum Effort Mayhem',
        description: 'Chaotic training that breaks all conventional rules',
        pattern: 'w@$x&*~^!',
        reps: 13,
        sets: 3,
        focus: 'Chaotic Excellence'
    },
    {
        id: 'fourth-wall-breaking-fitness',
        name: 'Fourth Wall Breaking Fitness',
        description: 'Meta-training that acknowledges you are doing a workout in a game',
        pattern: '!^~*&x$@w',
        reps: 16,
        sets: 3,
        focus: 'Meta Conditioning'
    },
    {
        id: 'regeneration-recovery-protocol',
        name: 'Regeneration Recovery Protocol',
        description: 'Healing-focused training for those who bounce back from anything',
        pattern: 'x&*w@~^',
        reps: 19,
        sets: 3,
        focus: 'Instant Recovery'
    },
    {
        id: 'merc-with-a-mouth-workout',
        name: 'Merc With A Mouth Workout',
        description: 'Talk through the pain while building mercenary-level conditioning',
        pattern: '$w@*&x~',
        reps: 17,
        sets: 3,
        focus: 'Mercenary Endurance'
    },
    {
        id: 'chimichangas-and-gains',
        name: 'Chimichangas and Gains',
        description: 'Unconventional nutrition meets unconventional training methods',
        pattern: '~^w@&*x!',
        reps: 14,
        sets: 3,
        focus: 'Unconventional Power'
    },
    {
        id: 'red-suit-rampage',
        name: 'Red Suit Rampage',
        description: 'High-intensity chaos training in signature red and black style',
        pattern: 'w@!~^*&x$',
        reps: 21,
        sets: 3,
        focus: 'Signature Chaos'
    }
];

// Iron Man's workout programs (expanded from 1 to 6)
const ironManPrograms = [
    {
        id: 'arc-reactor-core-training',
        name: 'Arc Reactor Core Training',
        description: 'Precision core conditioning to power advanced technological enhancements',
        pattern: '$x&*+=!',
        reps: 10,
        sets: 3,
        focus: 'Power Core Development'
    },
    {
        id: 'stark-tech-optimization',
        name: 'Stark Tech Optimization',
        description: 'Engineering-precision training protocols for maximum efficiency',
        pattern: '*&x$w@^',
        reps: 12,
        sets: 3,
        focus: 'Technical Precision'
    },
    {
        id: 'repulstor-ray-conditioning',
        name: 'Repulsor Ray Conditioning',
        description: 'Build the core stability needed to handle massive energy discharge',
        pattern: '^w@*&x$',
        reps: 15,
        sets: 3,
        focus: 'Energy Management'
    },
    {
        id: 'genius-billionaire-workout',
        name: 'Genius Billionaire Workout',
        description: 'High-tech training for the thinking person\'s superhero',
        pattern: '$*&xw@~',
        reps: 11,
        sets: 3,
        focus: 'Intellectual Fitness'
    },
    {
        id: 'armored-avenger-protocol',
        name: 'Armored Avenger Protocol',
        description: 'Training designed to complement advanced powered armor systems',
        pattern: 'x&$*w@^!',
        reps: 14,
        sets: 3,
        focus: 'Armor Integration'
    },
    {
        id: 'stark-industries-stamina',
        name: 'Stark Industries Stamina',
        description: 'Corporate executive conditioning for running both companies and superhero teams',
        pattern: 'w@^*&x$~',
        reps: 13,
        sets: 3,
        focus: 'Executive Endurance'
    }
];

// Thor's workout programs (expanded from 1 to 6)
const thorPrograms = [
    {
        id: 'god-of-thunder-training',
        name: 'God of Thunder Training',
        description: 'Divine strength training worthy of the Asgardian throne',
        pattern: '$x&*=!',
        reps: 8,
        sets: 3,
        focus: 'Divine Power'
    },
    {
        id: 'mjolnir-mastery-workout',
        name: 'Mjolnir Mastery Workout',
        description: 'Develop the worthiness and strength needed to wield the legendary hammer',
        pattern: '*&=$xw@',
        reps: 12,
        sets: 3,
        focus: 'Hammer Mastery'
    },
    {
        id: 'asgardian-warrior-conditioning',
        name: 'Asgardian Warrior Conditioning',
        description: 'Royal guard training protocols from the golden realm of Asgard',
        pattern: 'w@$*&x=',
        reps: 16,
        sets: 3,
        focus: 'Royal Guard Strength'
    },
    {
        id: 'rainbow-bridge-endurance',
        name: 'Rainbow Bridge Endurance',
        description: 'Cosmic-level conditioning for travel between the nine realms',
        pattern: '^=$*&xw@',
        reps: 10,
        sets: 3,
        focus: 'Cosmic Endurance'
    },
    {
        id: 'storm-lord-protocol',
        name: 'Storm Lord Protocol',
        description: 'Harness the power of lightning and thunder through divine conditioning',
        pattern: '$*&=xw@^',
        reps: 14,
        sets: 3,
        focus: 'Storm Control'
    },
    {
        id: 'all-father-preparation',
        name: 'All-Father Preparation',
        description: 'Training for those destined to rule and protect the nine realms',
        pattern: 'w@^=$*&x!',
        reps: 18,
        sets: 3,
        focus: 'Royal Responsibility'
    }
];

// Main hero trainers data object
const heroTrainersData = {
    'spider-man': {
        id: 'spider-man',
        name: 'Spider-Man',
        specialization: 'Bodyweight Agility & Wall-Crawling Specialist',
        image: '/assets/images/spiderman.jpg',
        experience: '15+ years',
        category: 'hero',
        color: '#DC143C',
        secondaryColor: '#FF0000',
        intro: `Peter Parker gained his incredible abilities from a radioactive spider bite, but his true strength comes from never giving up and always doing what's right. As Spider-Man, he developed training methods that maximize bodyweight conditioning, focusing on the agility, core strength, and reflexes needed to swing through New York City while fighting crime.`,
        programs: spiderManPrograms
    },
    'captain-america': {
        id: 'captain-america',
        name: 'Captain America',
        specialization: 'Super Soldier Training & Balanced Development',
        image: '/assets/images/captainamerica.jpg',
        experience: '80+ years',
        category: 'hero',
        color: '#002868',
        secondaryColor: '#BF0A30',
        intro: `Steve Rogers transformed from a frail young man into the pinnacle of human perfection through the Super Soldier Serum and unwavering determination. As Captain America, he represents the perfect balance of strength, endurance, agility, and character that defines what it means to be a true hero.`,
        programs: captainAmericaPrograms
    },
    'wolverine': {
        id: 'wolverine',
        name: 'Wolverine',
        specialization: 'Berserker Training & Recovery Specialist',
        image: '/assets/images/wolverine.jpg',
        experience: '150+ years',
        category: 'hero',
        color: '#FFD700',
        secondaryColor: '#000080',
        intro: `Logan has lived through more battles than any human should endure, developing an uncompromising approach to training that mirrors his adamantium will. His healing factor allows for extreme training methods that push beyond normal human limits, teaching others how to recover faster and train harder.`,
        programs: wolverinePrograms
    },
    'deadpool': {
        id: 'deadpool',
        name: 'Deadpool',
        specialization: 'Unconventional Training & Maximum Effort',
        image: '/assets/images/deadpool.jpg',
        experience: '20+ years',
        category: 'hero',
        color: '#FF0000',
        secondaryColor: '#000000',
        intro: `Wade Wilson brings maximum effort and maximum chaos to every training session. His unconventional methods break all the rules but somehow deliver incredible results. Warning: Training with Deadpool may cause unexpected laughter and occasional breaking of the fourth wall.`,
        programs: deadpoolPrograms
    },
    'iron-man': {
        id: 'iron-man',
        name: 'Iron Man',
        specialization: 'Technology-Enhanced Training & Precision',
        image: '/assets/images/ironman.jpg',
        experience: '15+ years',
        category: 'hero',
        color: '#FFD700',
        secondaryColor: '#DC143C',
        intro: `Tony Stark approaches fitness with the same genius-level intellect he brings to engineering. His training protocols are precisely calculated for maximum efficiency, incorporating cutting-edge technology and scientific principles to optimize human performance.`,
        programs: ironManPrograms
    },
    'thor': {
        id: 'thor',
        name: 'Thor',
        specialization: 'Divine Strength & Worthiness Training',
        image: '/assets/images/thor.jpg',
        experience: '1500+ years',
        category: 'hero',
        color: '#C0C0C0',
        secondaryColor: '#FF0000',
        intro: `Thor Odinson brings the training wisdom of Asgard to Midgard, combining divine strength with the humility learned through exile. His programs focus not just on physical power, but on developing the worthiness and character that define a true hero.`,
        programs: thorPrograms
    },
};

// Export the data - THIS IS THE CRITICAL LINE
export default heroTrainersData;